import { WishlistItemDto } from '../dto/wishlist.dto';

export class WishlistService {
  static getWishlist(): WishlistItemDto[] {
    try {
      const stored = localStorage.getItem('wishlistItems');
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  }

  static addItem(item: WishlistItemDto): WishlistItemDto[] {
    const wishlist = WishlistService.getWishlist();
    const exists = wishlist.some(
      w => w.product.id === item.product.id && w.variantSku === item.variantSku
    );
    const updated = exists ? wishlist : [...wishlist, item];
    localStorage.setItem('wishlistItems', JSON.stringify(updated));
    return updated;
  }

  static removeItem(productId: string, variantSku?: string): WishlistItemDto[] {
    const wishlist = WishlistService.getWishlist();
    const updated = wishlist.filter(
      w => !(w.product.id === productId && w.variantSku === variantSku)
    );
    localStorage.setItem('wishlistItems', JSON.stringify(updated));
    return updated;
  }

  static clearWishlist(): void {
    localStorage.removeItem('wishlistItems');
  }
}
